<template>
	<router-view></router-view>
</template>

<script>

export default {
	name: "BareBonesLayout",
};
</script>

<style lang="scss">
.intercom-launcher {
	/* hide the intercom widget; it will still be loaded on the page */
	display: none;

	&.manifest {
		display: block !important;
	}
}
</style>
